const Chart = require('chart.js')
const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		tableComponentClass: 'templates_mblx_products_additionalInformation_table',
		controllerComponentClass: 'templates_mblx_products_additionalInformation_controller',
		chartProperties: {
			type: 'doughnut',
			data: [],
			options: {
				legend: {
					display: false
					// position: 'right',
				},
				// events: [],
				tooltips: {
					enabled: false
				},
				// animation: {
				// 	duration: 0 // general animation time
				// },
				hover: {
					animationDuration: 0 // duration of animations when hovering an item
				},
				cutoutPercentage: 45,
				// responsiveAnimationDuration: 0, // animation duration after a resize
				aspectRatio: 1,
				// responsive: false,
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0
					}
				}
			}
		},
	},

	model: {
		chartProperties: {},
		stats: null,
	},

	methods: {

		prepare(storage, isServer){
			if(!isServer){
				this.locate(`< ${this.config.controllerComponentClass} > ${this.config.tableComponentClass}`, table => {
					this.model.stats = table.resourceData.stats || {}
				})
			}
		},

		initChart(){
			if(!this.model.chart && this.$ && this.$.length > 0){
				this.model.chart = new Chart(this.$.find('> .canvasContainer > canvas.chart'), this.model.chartProperties)
			}
		},

		update(stats) {
			this.initChart()

			if(this.model.chart && stats && this.$ && this.$.length > 0){
				const preparedStats = utils.chart.normalizeClasses({
					none: 			stats.none || 0,
					transport: 		stats.transport || 0,
					requestSuccess: stats.requestSuccess || 0,
					notifySuccess: 	stats.notifySuccess || 0,
					errors: (
						(stats.transportError || 0) +
						(stats.requestError || 0) +
						(stats.notifyError || 0) +
						(stats.notifyTimeout || 0)
					),
				})

				this.model.chart.data.labels = [
					storage.__('productAdditionalInformation.stats.externalApiStatus.transport', { nrOfElements: preparedStats.original.absolute.transport }),
					storage.__('productAdditionalInformation.stats.externalApiStatus.requestSuccess', { nrOfElements: preparedStats.original.absolute.requestSuccess }),
					storage.__('productAdditionalInformation.stats.externalApiStatus.notifySuccess', { nrOfElements: preparedStats.original.absolute.notifySuccess }),

					storage.__('productAdditionalInformation.stats.externalApiStatus.error', { nrOfElements: preparedStats.original.absolute.errors }),
					storage.__('productAdditionalInformation.stats.externalApiStatus.none', { nrOfElements: preparedStats.original.absolute.none }),
				]
				this.model.chart.data.datasets[0].data = [

					preparedStats.normalized.relative.transport,
					preparedStats.normalized.relative.requestSuccess,
					preparedStats.normalized.relative.notifySuccess,

					preparedStats.normalized.relative.errors,
					preparedStats.normalized.relative.none,
				]

				const $legend = this.$.find('.legend')
				$legend.html(this.model.chart.generateLegend())
				this.model.chart.update()
			}
		},
	},

	hooks: {

		attach: function($element, options){

			// in case of refreshes the chart-dom-binding has to be renewed
			if (this.model.chart && (options || {}).refresh){
				this.model.chart.destroy()
				delete this.model.chart
			}
			if(!this.model.chart){
				this.model.chartProperties = this.config.chartProperties
				this.model.chartProperties.data = {
					datasets: [{
						data: [],
						backgroundColor: [
							'#90C190',
							'#1E931E',
							'#006600',

							'#B20000',
							'#666666',
						],
						hoverBackgroundColor: [
							'#90C190',
							'#1E931E',
							'#006600',

							'#B20000',
							'#666666',
						],
						borderColor: [
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
						],
						categoryPercentage: 1,
						barPercentage: 1,
					}]
				}
				this.initChart()
			}

			if(this.model.stats){
				this.update(this.model.stats)
			}
		},
	},

	handlers: [{
		name: 'refreshResources',
		handle: function(callerComponent) {
			if(callerComponent.componentClass === this.config.tableComponentClass && this.config.isReady && this.$ && this.$.length > 0){
				this.refresh()
			}
		}
	}]
}
